/* eslint-disable no-unused-vars */
import { globalClasses } from "helper/globalClasses";
import { globalVariables } from "helper/globalVariables";
import { viewMore } from "helper/icons";
import { useContext, useEffect, useRef, useState } from "react";
import { useMediaQuery } from "react-responsive";
import { ResultCard } from "./ResultCard";
import "./module.css";
import { Button } from "shared/Components/button";
import Dropdown from "shared/Components/dropdown";
import { TableWithPagination } from "shared/Components/tableWithPagination";
import { useNavigate } from "react-router-dom";
import { TrialResultCard } from "./TrialResultCard";
import Modal from "shared/Components/modal";
import { useLazyQuery } from "@apollo/client";
import { TrialCalendarQuery } from "redux/features/trialCalendar/trialCalendarGql";
import moment from "moment";
import { MobilePagination } from "shared/Components/mobilePagination";
import { SearchLocation } from "shared/Components/searchLocation";
import Loader from "shared/Components/loader";
import PageInfo from "shared/Components/pageInfo";
import {
  PageContext,
  PageDispatchContext,
} from "shared/context/paginationCotnext";
import { DEFAULT_DATE_FORMAT } from "helper/utility";
import useEffectAfterMount from "helper/useEffectAfterMount";
import { RoleContext } from "context/RoleContext";
import { CustomDateRangePicker } from "shared/Components/customDateRangePicker";
import { removeDuplicates } from "helper/removeDuplicates";

const headData = [
  globalVariables.date,
  globalVariables.trialName,
  globalVariables.city,
  globalVariables.state,
  globalVariables.level,
  globalVariables.viewResults,
];

const noviceDropdownData = [
  globalVariables.sit,
  globalVariables.novice,
  globalVariables.advanced,
  globalVariables.excellent,
  globalVariables.premier,
];

export const TrialResults = ({ setTrial = () => "" }) => {
  const page = useContext(PageContext);
  const Role = useContext(RoleContext);
  const setPage = useContext(PageDispatchContext);
  const navigate = useNavigate();
  const { tableDataCls } = globalClasses;
  const modalRef = useRef();
  const [dateFilter, setDateFilter] = useState(null);
  const [date, setDate] = useState({
    startDate: null,
    endDate: null,
  });
  const [cityFilter, setCityFilter] = useState(null);
  const [stateFilter, setStateFilter] = useState(null);
  const [levelFilter, setLevelFilter] = useState(null);
  const isSmallMobile = useMediaQuery({ query: "(max-width: 630px)" });
  const isMobile = useMediaQuery({ query: "(max-width: 630px)" });
  const [selectedTrialIndex, setSelectedTrialIndex] = useState(null);
  const { paginatedDataCls } = globalClasses;

  const [getData, { loading, error, data }] = useLazyQuery(TrialCalendarQuery, {
    fetchPolicy: "no-cache",
  });

  const resultData = data?.getAllTrialCalendar;
  const filteredTableData = resultData?.data || [];

  const handleDownloadIconClick = (e, data) => {
    e.stopPropagation();
    // setTrial(data);
  };

  const handlePaginationData = (page = 1) => {
    setPage(page);
  };

  useEffect(() => {
    getData({
      variables: {
        pageNumber: isMobile ? 1 : page,
        role: Role,
        pageSize: isMobile ? 1000 : 10,
        approvalStatus: "Approve",
        level: levelFilter,
        city: cityFilter,
        state: stateFilter,
        trialResult: true,
        fromDate: date.startDate
          ? moment(date.startDate).format("yyyy-MM-01")
          : null,
        toDate: date.endDate ? moment(date.endDate).format("yyyy-MM-31") : null,
      },
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, isMobile]);

  useEffect(() => {
    getData({
      variables: {
        pageNumber: 1,
        pageSize: isMobile ? 1000 : 10,
        role: Role,
        approvalStatus: "Approve",
        level: levelFilter,
        city: cityFilter,
        state: stateFilter,
        fromDate: date.startDate
          ? moment(date.startDate).format("yyyy-MM-01")
          : null,
        toDate: date.endDate ? moment(date.endDate).format("yyyy-MM-31") : null,
        trialResult: true,
      },
    });
    setPage(1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [levelFilter, cityFilter, stateFilter, date.startDate, date.endDate, isMobile]);

  const showResults = (trial) => {
    console.log("Trial Data here ", trial.id);

    return;
    // setTrial(trial);
  };

  const openModal = (trialIndex) => {
    setSelectedTrialIndex(trialIndex);
    modalRef.current.openModal();
  };

  const renderTableBody = () =>
    filteredTableData.map((trial, index) => (
      <tr
        className="cursor-default"
        key={trial.date}
        // onClick={() => setTrial(trial)}
      >
        <td className={paginatedDataCls(index)}>
          {moment.utc(trial?.trial?.trialDate).format(DEFAULT_DATE_FORMAT)}
        </td>
        <td className={paginatedDataCls(index)}>{trial?.trial?.trialName}</td>
        <td className={paginatedDataCls(index)}>{trial?.trial?.city}</td>
        <td className={paginatedDataCls(index)}>{trial?.trial?.state}</td>
        <td className={paginatedDataCls(index)}>{removeDuplicates(trial?.level)}</td>
        <td
          className={`${paginatedDataCls(index)} ${"cursor-pointer"}`}
          onClick={(event) => {
            console.log("TRial Data ", trial.id);
            navigate(`${trial.id}`);
            return;
            handleDownloadIconClick(event, trial);
          }}
        >
          <img src={viewMore} alt="" className="mx-auto" />
        </td>
      </tr>
    ));

  const onClearFilters = () => {
    setDate({
      startDate: null,
      endDate: null,
    });
    setCityFilter(null);
    setStateFilter(null);
    setLevelFilter(null);
  };

  return (
    <>
      <PageInfo title={globalVariables.trialResults}>
        <Button
          width={"w-auto"}
          label="Clear All Filters"
          onClick={onClearFilters} 
        />
      </PageInfo>
      <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-5 my-5">
            <CustomDateRangePicker
              defaultStartDate={date.startDate}
              defaultEndDate={date.endDate}
              isNavigation
              isShadow={true}
              width={"w-full"}
              onSetDate={(startDate, endDate) => {
                setDate({
                  ...date,
                  startDate: startDate ? new Date(startDate) : null,
                  endDate: endDate ? new Date(endDate) : null,
                });
              }}
            />
            <SearchLocation
              isShadow={true}
              width={"w-full"}
              name="State"
              types={["(regions)"]}
              placeholder={globalVariables.state}
              onSelectLocation={(location) => {
                setStateFilter(location);
              }}
              defaultValue={stateFilter}
            />
            <SearchLocation
              isShadow={true}
              width={"w-full"}
              name="city"
              placeholder={globalVariables.city}
              types={["(cities)"]}
              onSelectLocation={(location) => {
                setCityFilter(location);
              }}
              searchBy={stateFilter}
              defaultValue={cityFilter}
            />
            <Dropdown
              defaultOption={levelFilter}
              isShadow={true}
              dropdownOptions={noviceDropdownData}
              placeholder={globalVariables.level}
              width={"w-full"}
              showIconLeft
              onChange={setLevelFilter}
              isFaded={true}
              showCross={true}
            />
          </div>
      <div className="mt-6">
        <TableWithPagination
          headData={headData}
          tableBody={renderTableBody()}
          itemsPerPage={10}
          tableHeight={"md:h-[calc(100vh-14rem)] lg:h-[calc(100vh-13rem)]"}
          totalPage={resultData?.totalPages}
          handlePageChange={(page) => handlePaginationData(page)}
          loading={loading}
          error={error}
          persistPagination={true}
          current={page}
          isPagination={!isMobile}
        />
      </div>
    </>
  );
};
